<template>
  <fieldset class="tab tab-03">
    <div class="heading-form a-center">
      <span class="number">3/11</span>
      <p class="c-yellow">ข้อมูลส่วนตัว</p>
      <h2 class="heading-h2 c-white">ข้อมูลสำหรับติดต่อ</h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icm-readonly">
            <label for class="icw-label overlabel">
              เบอร์โทรศัพท์มือถือ
              <span class="c-star">
                <sup>*</sup>
              </span>
            </label>
            <input v-if="isConsentFlag == 'true'"
              type="text"
              id="txtMobileNo"
              v-model="phone"
              :class="{ 'input-required': !isPhoneValid }"
              maxlength="12"
              pattern="\d*"
              readonly
              @keyup="validMobile()"
            />
            <input v-else
              type="text"
              id="txtMobileNo"
              v-model="phone"
              :class="{ 'input-required': !isPhoneValid }"
              maxlength="12"
              pattern="\d*"
              @keyup="validMobile()"
            />
            <p class="input-note c-red" v-if="!isPhoneValid">ระบุเฉพาะตัวเลข 10 หลัก</p>
            <!-- <InputPattern type="text" placeholder="" v-model="phone" maxlength="10" :regExp="/^[0\D]*|\D*/g" pattern="\d*" /> -->
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for class="icw-label overlabel">อีเมล</label>
            <input
              type="email"
              id="txtEmail"
              v-model="email"
              :class="{ 'input-required': !isEmailValid }"
              maxlength="100"
              @blur="validEmailAlert()"
            />
            <p class="input-note c-red" v-if="!isEmailValid">รูปแบบอีเมลไม่ถูกต้อง</p>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input">
            <label for class="icw-label overlabel">LINE ID</label>
            <input type="text" id="txtLineID" maxlnegth="50" v-model="lineid" />
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="prevStep('tab-03', 'tab-02')"
      >ย้อนกลับ</button>
    </div>
    <button
      type="button"
      id="btnNextStepQ4"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >ถัดไป</button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import InputPattern from "vue-pattern-input";

import { my_storage, incCurrentStep } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";
import { is_email } from "@/helpers/validate_helper.js";

export default {
  name: "QuestionStep1_Q3",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  mounted() {
    const pNumber = my_storage("is_consent_phone", "value");
    this.isConsentFlag = sessionStorage.getItem("is_consent_flag");
    if (this.isConsentFlag == "true") {
      this.phone = pNumber;
    }
  },
  data() {
    return {
      phone: my_storage(this.QuestionType, "phone"),
      lineid: my_storage(this.QuestionType, "lineid"),
      email: my_storage(this.QuestionType, "email"),
      isPhoneValid: true,
      isEmailValid: true,
      isConsentFlag: true
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    validMobile() {
      this.isPhoneValid = true;
      let pass = true;
      if (this.phone == "") {
        pass = false;
      } else if (this.phone != "" && this.phone.length < 10) {
        pass = false;
      }
      if (!pass) this.isPhoneValid = false;
      return pass;
    },
    validEmail() {
      // this.isEmailValid = true
      let pass = true;
      if (this.email != "" && !is_email(this.email)) {
        pass = false;
      }
      // if (!pass) this.isEmailValid = false
      return pass;
    },
    validEmailAlert() {
      this.isEmailValid = true;
      let pass = true;
      if (this.email != "" && !is_email(this.email)) {
        pass = false;
      }
      if (!pass) this.isEmailValid = false;
      return pass;
    },
    beforeNextStep() {
      if (this.validMobile() && this.validEmail()) {
        sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));

        sessionStorage.setItem("userEmail", this.email);

        let currentTag = this.$vnode.componentOptions.tag;
        currentTag = currentTag.replace("Q", "");
        incCurrentStep("step1", currentTag);

        this.isError = false;
        this.wrongFormat = false;

        this.nextStep("tab-03", "tab-04");
      }
    }
  },
  watch: {
    phone: function(n, o) {
      let result = n.replace(/\D/g, "");
      if (result.length == 10) {
        result = result.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
      Vue.nextTick(() => (this.phone = result));
    },
    email: function(n, o) {
      Vue.nextTick(() => {
        this.email = n.replace(/[^a-zA-Z0-9\@\.\_\-]/g, "");
      });
    },
    lineid: function(n, o) {
      Vue.nextTick(() => {
        this.lineid = n.replace(/[^a-zA-Z0-9\@\.\_\-]/g, "");
      });
    }
  },
  computed: {
    isPass() {
      return this.isPhoneValid && this.validEmail();
    }
  }
};
</script>
